module.exports = __webpack_public_path__ + "img/logout.8544b040.svg";